/**
 * Thin registry that lets the vortex entry point register route bundles.
 */
type BundleLoader = (pathname: string) => Promise<void>;

let _loader: BundleLoader | null = null;

export function registerBundleLoader(loader: BundleLoader): void {
  _loader = loader;
}

export function loadBundlesForPath(pathname: string): Promise<void> {
  return _loader?.(pathname) ?? Promise.resolve();
}
